(function () {
  if (window.CDRefillRecs) return;

  var sections = [];
  var ticking = false;
  var rebuildTimer = null;
  var reduceMotionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function splitRenderedLines(node, text) {
    var words = text.split(/\s+/).filter(Boolean);
    if (!words.length) return text ? [text] : [];

    var width = Math.round(node.getBoundingClientRect().width || node.offsetWidth || 0);
    if (width <= 2) return [text];

    var measure = document.createElement(node.tagName || 'span');
    var computed = window.getComputedStyle(node);

    measure.style.position = 'absolute';
    measure.style.left = '-99999px';
    measure.style.top = '0';
    measure.style.visibility = 'hidden';
    measure.style.pointerEvents = 'none';
    measure.style.width = width + 'px';
    measure.style.maxWidth = 'none';
    measure.style.whiteSpace = 'normal';
    measure.style.font = computed.font;
    measure.style.fontFamily = computed.fontFamily;
    measure.style.fontSize = computed.fontSize;
    measure.style.fontWeight = computed.fontWeight;
    measure.style.letterSpacing = computed.letterSpacing;
    measure.style.lineHeight = computed.lineHeight;
    measure.style.textTransform = computed.textTransform;
    measure.style.textAlign = computed.textAlign;

    document.body.appendChild(measure);

    var spans = words.map(function (word, index) {
      var span = document.createElement('span');
      span.textContent = index === words.length - 1 ? word : word + ' ';
      span.style.display = 'inline-block';
      span.style.whiteSpace = 'pre';
      measure.appendChild(span);
      return span;
    });

    var lines = [];
    var current = [];
    var currentTop = null;

    spans.forEach(function (span) {
      var top = span.offsetTop;
      if (currentTop === null) currentTop = top;
      if (Math.abs(top - currentTop) > 2 && current.length) {
        lines.push(current.join('').trim());
        current = [];
        currentTop = top;
      }
      current.push(span.textContent || '');
    });

    if (current.length) lines.push(current.join('').trim());
    measure.remove();
    return lines.length ? lines : [text];
  }

  function buildLineflow(root) {
    root.querySelectorAll('[data-cd-rr-lineflow]').forEach(function (node) {
      var original = node.getAttribute('data-cd-rr-original');
      if (!original) {
        original = (node.innerHTML || '').trim();
        node.setAttribute('data-cd-rr-original', original);
      }

      var raw = original
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .trim();

      if (!raw) return;

      var segments = raw
        .split(/\n+/)
        .map(function (segment) { return segment.replace(/\s+/g, ' ').trim(); })
        .filter(Boolean);

      node.innerHTML = '';
      node.setAttribute('aria-label', segments.join(' '));

      var lineIndex = 0;
      segments.forEach(function (segment) {
        splitRenderedLines(node, segment).forEach(function (lineText) {
          var line = document.createElement('span');
          line.className = 'cd-rr-line';
          line.style.setProperty('--cd-rr-line-index', String(lineIndex));

          var text = document.createElement('span');
          text.className = 'cd-rr-line__text';
          text.textContent = lineText;

          line.appendChild(text);
          node.appendChild(line);
          lineIndex += 1;
        });
      });
    });
  }

  function setupSection(section) {
    if (!section || section.dataset.cdRrReady === 'true') return null;
    section.dataset.cdRrReady = 'true';

    buildLineflow(section);

    var items = Array.prototype.slice.call(section.querySelectorAll('[data-cd-rr-item]'));
    items.forEach(function (item) {
      var step = parseFloat(item.getAttribute('data-cd-rr-step') || '0') || 0;
      item.style.setProperty('--cd-rr-step', String(step));
    });

    var entry = { root: section, items: items };
    sections.push(entry);
    return entry;
  }

  function revealSection(entry) {
    if (!entry || !entry.root) return;
    entry.root.classList.add('is-visible');

    entry.items.forEach(function (item) {
      if (item.classList.contains('is-visible')) return;
      var step = parseFloat(item.getAttribute('data-cd-rr-step') || '0') || 0;
      window.setTimeout(function () {
        item.classList.add('is-visible');
      }, reduceMotionQuery && reduceMotionQuery.matches ? 0 : step * 90);
    });
  }

  function updateEntry(entry) {
    if (!entry || !entry.root) return;
    if (reduceMotionQuery && reduceMotionQuery.matches) {
      revealSection(entry);
      return;
    }

    var rect = entry.root.getBoundingClientRect();
    var viewport = window.innerHeight || 1;
    if (rect.top <= viewport * 0.88 && rect.bottom >= viewport * 0.06) {
      revealSection(entry);
    }
  }

  function updateAll() {
    sections.forEach(updateEntry);
    ticking = false;
  }

  function queueUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateAll);
  }

  function init(context) {
    (context || document).querySelectorAll('[data-cd-rr-section]').forEach(setupSection);
    queueUpdate();
  }

  function rebuild() {
    sections.forEach(function (entry) {
      if (!entry || !entry.root) return;
      buildLineflow(entry.root);
      entry.items = Array.prototype.slice.call(entry.root.querySelectorAll('[data-cd-rr-item]'));
    });
    queueUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.addEventListener('load', function () {
    init(document);
    rebuild();
  });

  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', function () {
    clearTimeout(rebuildTimer);
    rebuildTimer = window.setTimeout(rebuild, 120);
    queueUpdate();
  });
  window.addEventListener('orientationchange', function () {
    clearTimeout(rebuildTimer);
    rebuildTimer = window.setTimeout(rebuild, 120);
    queueUpdate();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
    rebuild();
  });

  if (reduceMotionQuery && typeof reduceMotionQuery.addEventListener === 'function') {
    reduceMotionQuery.addEventListener('change', rebuild);
  }

  window.CDRefillRecs = {
    init: init,
    refresh: queueUpdate,
    rebuild: rebuild
  };
})();
